let config = {
    development: {
        apiHost: 'http://localhost:3000',
        assetsHost: "https://virtap.s3.amazonaws.com/test",
        videosHost: "https://streaming.virtap.com.br/aulas",
        coursesHost: "https://streaming.virtap.com.br/cursos",
        introAVCompletePage: "http://localhost:8000/curso-gratuito-concluido",
        virtapClubPage: "http://localhost:8000/virtap-club.html",
        loginPage: "http://localhost:8000/login.html",
        formAPPage: "http://localhost:8000/formacoes/assistencia-pessoal/",
        signupPage: "http://localhost:8000/cadastrar.html",
        profilePage: "http://localhost:8000/perfil.html",
        purchasePage: "http://localhost:8000/comprar.html",
        offers: {
            FORMACAO_AV_MTD_VIRTAP_ELITE_TRI_797: {
                wistiaVideoId: 's6hvrvdx24',
                offerPath: 'oferta-fav-plat-797'
            },

            FORMACAO_AV_MTD_VIRTAP_ELITE_TRI_997: {
                wistiaVideoId: '45oze4ini2',
                offerPath: 'oferta-fav-plat-997'
            },

            
            PRIMEIRO_CLIENTE_AV_97: {
                wistiaVideoId: 'swje93t2pi',
                offerPath: 'oferta-cliente-av-97'
            },

            PRIMEIRO_CLIENTE_AV_197: {
                wistiaVideoId: 'egvdc19103',
                offerPath: 'oferta-cliente-av-197'
            }

        }   
    },
    production: {
        apiHost: 'https://api.virtap.com.br',
        assetsHost: "https://virtap.s3.amazonaws.com/production",
        videosHost: "https://streaming.virtap.com.br/aulas",
        coursesHost: "https://streaming.virtap.com.br/cursos",
        introAVCompletePage: "https://www.virtap.com.br/curso-gratuito-concluido",
        virtapClubPage: "https://www.virtap.com.br/virtap-club",
        loginPage: "https://www.virtap.com.br/login",
        formAPPage: "https://www.virtap.com.br/formacoes/assistencia-pessoal/",
        signupPage: "https://www.virtap.com.br/cadastrar",
        profilePage: "https://www.virtap.com.br/perfil",
        purchasePage: "https://www.virtap.com.br/comprar",
        offers: {
            FORMACAO_AV_MTD_VIRTAP_ELITE_TRI_797: {
                wistiaVideoId: 's6hvrvdx24',
                offerPath: 'oferta-fav-plat-797'
            },

            FORMACAO_AV_MTD_VIRTAP_ELITE_TRI_997: {
                wistiaVideoId: '45oze4ini2',
                offerPath: 'oferta-fav-plat-997'
            },

            PRIMEIRO_CLIENTE_AV_97: {
                wistiaVideoId: 'swje93t2pi',
                offerPath: 'oferta-cliente-av-97'
            },

            PRIMEIRO_CLIENTE_AV_197: {
                wistiaVideoId: 'egvdc19103',
                offerPath: 'oferta-cliente-av-197'
            }

        }   
    }
}

export default config[process.env.NODE_ENV];
